var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.75 5H3.25A1.25 1.25 0 0 0 2 6.25v7.5A1.25 1.25 0 0 0 3.25 15H14l5.2 3.9a.5.5 0 0 0 .8-.4V15h.75A1.25 1.25 0 0 0 22 13.75v-7.5A1.25 1.25 0 0 0 20.75 5ZM6.5 11.5A1.5 1.5 0 1 1 8 10a1.5 1.5 0 0 1-1.5 1.5Zm5.5 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5Zm5.5-3A1.5 1.5 0 1 1 16 10a1.5 1.5 0 0 1 1.5-1.5Z"
})));
export default SvgChat;